class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.initialized = false;
    this.parser = new DOMParser();

    this.url = this.dataset.url;
    this.limit = parseInt(this.dataset.limit, 10) || 16;
    this.productIds = this.dataset.productIds.split(',');
    this.sectionId = this.dataset.sectionId;
    this.emptySectionClass = 'related-products--empty';

    setTimeout(() => this.init(), 2500);

    isIntersecting(this, () => {
      this.closest('section').dataset.intersected = true;

      this.init();
    }, '400px');
  }

  async init() {
    if (this.initialized) return;

    this.initialized = true;

    if (this.productIds.length === 1) {
      const html = await fetch(`${ this.url }&product_id=${ this.productIds[0] }&section_id=${ this.sectionId }`).then(res => res.text());
      const doc = this.parser.parseFromString(html, 'text/html');

      this.innerHTML = doc.querySelector(`product-recommendations[data-section-id="${ this.sectionId }"]`)?.innerHTML || '';

      this.#syncEmptySectionClass();
      return;
    }

    let recommendationsHtml = '';
    const fragment = new DocumentFragment();
    const requests = this.productIds.map((id, i) =>
      fetch(`${ this.url }&product_id=${ id }&section_id=${ this.sectionId }`)
        .then(res => res.text())
        .then(html => {
          const doc = this.parser.parseFromString(html, 'text/html');

          if (i === 0 && !recommendationsHtml) {
            recommendationsHtml = doc.querySelector(`product-recommendations[data-section-id="${ this.sectionId }"]`);
          }

          return Array.from(
            doc.querySelectorAll(`product-recommendations[data-section-id="${ this.sectionId }"] .swiper-slide`)
          );
        })
    );
    const duplicates = new Set();
    const results = (await Promise.all(requests)).map(result =>
      result.filter(s => {
        if (duplicates.has(s.dataset.id)) return false;

        duplicates.add(s.dataset.id);
        return true;
      })
    );
    const mixed = this.roundRobin(results, this.limit);

    const wrapper = recommendationsHtml?.querySelector('.swiper-wrapper');

    if (!recommendationsHtml || !wrapper) {
      this.innerHTML = '';
      this.#syncEmptySectionClass();
      return;
    }

    recommendationsHtml.querySelectorAll('.swiper-slide').forEach(s => s.remove());
    mixed.forEach(m => fragment.appendChild(m));
    wrapper.appendChild(fragment);

    this.innerHTML = recommendationsHtml.innerHTML;
    this.#syncEmptySectionClass();
  }

  #syncEmptySectionClass() {
    const section = this.closest('.related-products');

    if (!section) {
      return;
    }

    const hasProducts = this.querySelectorAll('.swiper-slide').length > 0;

    section.classList.toggle(this.emptySectionClass, !hasProducts);
  }

  roundRobin(lists, limit) {
    const result = [];
    let index = 0;

    while (result.length < limit) {
      let added = false;

      for (let i = 0; i < lists.length; i++) {
        if (lists[i][index]) {
          result.push(lists[i][index]);
          added = true;
          if (result.length === limit) break;
        }
      }

      if (!added) break;

      index++;
    }

    return result;
  }
}

customElements.define('product-recommendations', ProductRecommendations);
